<template>
    <div class="appointment jumbotron d-flex align-items-center">
        <div class="appointment-info flex-grow-1">
            <span class="d-block">
                <fa-icon icon="user" class="mr-2" /> {{ capitalize(appointment.name) }}
            </span>

            <span>
                <fa-icon icon="mobile" class="mr-2" /> {{ appointment.telephone }}
            </span>
        </div>

        <b-button
            v-if="appointment.person_id"
            type="button"
            variant="outline-primary"
            v-b-tooltip.hover
            class="mr-1"
            title="Bekijk persoon"
            :to="{ name: 'personEdit', params: { personId: appointment.person_id } }"
        >
            <fa-icon icon="user" />
        </b-button>

        <b-button
            v-if="appointment.note"
            type="button"
            variant="outline-success"
            v-b-tooltip.hover
            class="mr-1"
            :title="appointment.note"
        >
            <fa-icon icon="question-circle" />
        </b-button>

        <b-button
            type="button"
            variant="danger"
            v-b-tooltip.hover
            title="Afspraak annuleren"
            @click="doDelete"
        >
            <fa-icon v-if="!isDeleting" icon="trash" />
            <loader-spinner v-else iscolor="#F0F0F0" :show-spinner="true" />
        </b-button>
    </div>
</template>

<script>
import LoaderSpinner from '../../elements/LoaderSpinner';
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        LoaderSpinner
    },
    props: {
        appointment: {
            type: Object,
        },
    },
    data: () => ({
        isDeleting: false,
    }),
    computed: {
    },
    methods: {
        ...mapActions([
            'deleteAppointment',
        ]),

        async doDelete() {
            this.isDeleting = true;

            try {
                await this.deleteAppointment(this.appointment.id);

                this.isDeleting = false;

                this.$emit('deleted')
            }
            catch (error) {
                console.log(error);

                this.isDeleting = false;
            }
        }
    },
    mounted () {}
}
</script>

<style lang="scss">
.appointment {
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem !important;

    &-info {
        font-size: 1.125rem;
        color: black;
    }
}
</style>


// WEBPACK FOOTER //
// Appointment.vue?2ff9a918